import CardDisplay from './CardDisplay';
export default CardDisplay;